import { render, staticRenderFns } from "./TrackingDetailsSkeleton.vue?vue&type=template&id=0e947ca5&scoped=true"
var script = {}
import style0 from "./TrackingDetailsSkeleton.vue?vue&type=style&index=0&id=0e947ca5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e947ca5",
  null
  
)

export default component.exports